module.exports = __webpack_public_path__ + "static/media/Location_Book-Page19.16d4eb86.png";